<template>
  <div>
    <ValidationObserver
      ref="form"
      v-slot="{ invalid, validate, dirty }">
      <form
        @submit.prevent="validate().then(updateSettings)"
        autocomplete="off">
        <div class="row">
          <div class="col-12 mb-2">
            <h4>Notification Emails</h4>
            <p class="category no-text-transform">
              The following email addresses will be sent emails when notifiable events occur.
            </p>
          </div>
          <div class="col-lg-4 col-md-6">
            <ValidationProvider
              name="Send To 1"
              rules="email|required"
              v-slot="{ errors }">
              <base-input
                name="notificationToEmail"
                label="Send To 1"
                type="email"
                autocomplete="new-email"
                v-model.trim="notificationEmails[0]"
                :error="errors[0]" />
            </ValidationProvider>
          </div>
          <div
            class="col-lg-4 col-md-6"
            v-for="(email, index) in additionalNotificationEmails"
            :key="index">
            <ValidationProvider
              :name="`Send To ${index + 2}`"
              rules="email"
              v-slot="{ errors }">
              <base-input
                focus
                v-focus
                autocomplete="new-email"
                :name="`notificationToEmail${index + 2}`"
                type="email"
                :label="`Send To ${index + 2}`"
                v-model.trim="notificationEmails[index + 1]"
                :error="errors[0]" />
            </ValidationProvider>
          </div>
          <div class="col-12">
            <base-button
              class="pl-0"
              link
              type="primary"
              @click="notificationEmails.push('');">
              Add Email
            </base-button>
          </div>
        </div>
        <!-- <el-divider /> -->
        <base-button
          :disabled="invalid || !dirty"
          native-type="submit"
          type="primary"
          class="btn-fill">
          Update
        </base-button>
      </form>
    </ValidationObserver>
  </div>
</template>
<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { Divider } from 'element-ui';

export default {
  name: 'SettingsEmails',
  components: {
    ValidationObserver,
    ValidationProvider,
    [Divider.name]: Divider,
  },
  props: {
    settings: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      notificationEmails: this.settings.notification_emails?.split(',') || [''],
    };
  },
  computed: {
    additionalNotificationEmails() {
      // exclude first result
      return this.notificationEmails.slice(1);
    },
  },
  methods: {
    updateSettings() {
      // Remove duplicates, filter empty
      this.notificationEmails = [...new Set(this.notificationEmails)].filter(e => e);
      this.$emit('updateSettings', {
        input: {
          notification_emails: this.notificationEmails.join(','),
        },
      });
      this.$refs.form.reset();
    },
  },
};
</script>

<style>
.no-text-transform {
  text-transform: none!important;
}
</style>
